import {LOGIN_DETAILS,LOGOUT_DETAILS, MODULE,FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT,MODULE_AND_LOGINDIV_DISABLED} from './LoginType'


export const loginCredential=(props)=>
{
    return{
        type:LOGIN_DETAILS,
        UserName:props.UserName,
        Password:props.Password,
        Role:props.Role,
        CheckInRights:props.CheckInRights,
        BoardingRights: props.BoardingRights,
        Token:props.Token,
        Theme:props.Theme,
        IsLogin:props.IsLogin,
        Location:props.Location,
        RoleCode: props.RoleCode,
        bp: props.bp,
        bt: props.bt,
        // isFlyBigRequired: props.isFlyBigRequired
    }
}
export const logoutCredential=(props)=>
{
     
    return{
        type:LOGOUT_DETAILS,
        UserName:props.UserName,
        Password:props.Password,
        Role:props.Role,
        CheckInRights:props.CheckInRights,
        BoardingRights: props.BoardingRights,
        Token:props.Token,
        Theme:props.Theme,
        IsLogin:props.IsLogin,
        bp: props.bp,
        bt: props.bt,
        // isFlyBigRequired: props.isFlyBigRequired
    }
}

export const moduleDropdown=(props)=>
{
    return{
        type:MODULE,
        Module:props.module
    }
}

export const FocusToSubheaderOfSeatmanagementCredential = (props) => {
    return {
        type: FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT,
        isFocusToSubheaderOfSeatmanagement: props.isFocusToSubheaderOfSeatmanagement
    }
}

export const moduleAndLoginDivDisabled = (props) => {
    return {
        type: MODULE_AND_LOGINDIV_DISABLED,
        IsModulAndLoginDivDisabled: props.IsModulAndLoginDivDisabled
    }
}